export const baseurl = 'https://sisccltd.com/omca_crm/api/'  //server
export const image = 'https://sisccltd.com/omca_crm/'  //server
export const imageUrl = 'https://sisccltd.com/omca_crm/'  //server

export const resolveCrmImageUrl = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (raw.startsWith("blob:") || raw.startsWith("data:")) return raw;

  const base = image.endsWith("/") ? image : `${image}/`;
  if (raw.startsWith(base)) return raw;

  const fileName = raw.split("?")[0].split("/").filter(Boolean).pop();
  if (!fileName) return "";
  return `${base}${fileName}`;
};
export const baseu11 = 'https://sisccltd.com/omca_crm'  //server
/** Socket.IO host + path (proxied under /omca_crm) */
export const socketUrl = 'https://sisccltd.com'
export const socketPath = '/omca_crm/socket.io'
export const excelExoprt = 'https://sisccltd.com/'  //server
export const AdminBaseUrl ="https://omcacrm.com/omca/api/crm/"
export const AdminBaseUrl1 ="https://omcacrm.com/omca/api/"
// https://omcacrm.com/omca/api/crm
// export const AdminBaseUrl ="https://omcacrm.com/omca/api/crm/"
// export const baseurl = 'http://192.168.1.77:5201/api/'
// export const baseu11 = 'http://192.168.1.77:5201'
// export const excelExoprt = 'http://192.168.1.77:5201/api/'
// export const image = 'https://sisccltd.com/omca_crm/'     
// export const imageUrl = 'http://192.168.1.77:5201/uploads/'  //local   
